"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

var _PricingTable = _interopRequireDefault(require("./PricingTable"));

var _QuantityTable = _interopRequireDefault(require("./QuantityTable"));

var _ErrorTable = _interopRequireDefault(require("./ErrorTable"));

var DELAY = 300;

var PricingGridLayout =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PricingGridLayout, _Component);

  function PricingGridLayout() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PricingGridLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PricingGridLayout)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      addedQuantities: undefined,
      addTimeoutId: undefined,
      deletedIndex: undefined,
      deleteTimeoutId: undefined,
      resetting: false,
      resetTimeoutId: undefined,
      showAlert: false
    };

    _this.componentDidUpdate = function (prevProps) {
      var showAlert = _this.state.showAlert;
      var priceExplorerUserSettings = prevProps.priceExplorerUserSettings;

      if (priceExplorerUserSettings && priceExplorerUserSettings.isUserNotifiedOnQuantityChange === false && !showAlert) {
        _this.props.userHasBeenNotifiedOfQuantityChange();

        _this.setState({
          showAlert: true
        });
      }
    };

    _this.clearAddedTimeout = function () {
      var addTimeoutId = _this.state.addTimeoutId;
      addTimeoutId && clearTimeout(addTimeoutId);

      _this.setState({
        addedQuantities: undefined,
        addTimeoutId: undefined
      });
    };

    _this.addQuantities = function (quantities) {
      _this.clearAddedTimeout();

      _this.props.addQuantities(quantities);

      _this.setState({
        addedQuantities: quantities,
        addTimeoutId: setTimeout(_this.clearAddedTimeout, DELAY)
      });
    };

    _this.deleteQuantity = function (index) {
      // finish any pending deletion
      _this.deleteImmediately(); // queue up new deletion


      _this.setState({
        deletedIndex: index,
        deleteTimeoutId: setTimeout(_this.deleteImmediately, DELAY)
      });
    };

    _this.deleteImmediately = function () {
      var _this$state = _this.state,
          deletedIndex = _this$state.deletedIndex,
          deleteTimeoutId = _this$state.deleteTimeoutId;
      deleteTimeoutId && clearTimeout(deleteTimeoutId);

      if (deletedIndex !== undefined) {
        _this.props.deleteQuantity(deletedIndex);
      }

      _this.setState({
        deletedIndex: undefined,
        deleteTimeoutId: undefined
      });
    };

    _this.resetQuantities = function () {
      // finish any pending resets
      _this.resetImmediately(); // queue up new reset


      _this.setState({
        resetting: true,
        resetTimeoutId: setTimeout(_this.resetImmediately, DELAY)
      });
    };

    _this.resetImmediately = function () {
      var _this$state2 = _this.state,
          resetting = _this$state2.resetting,
          resetTimeoutId = _this$state2.resetTimeoutId;
      resetTimeoutId && clearTimeout(resetTimeoutId);

      if (resetting) {
        _this.props.resetQuantities();
      }

      _this.setState({
        resetting: false,
        resetTimeoutId: undefined
      });
    };

    _this.displayAlert = function (type, message) {
      return _react.default.createElement(_reactComponents.Alert, {
        type: type,
        message: message,
        dismissed: false
      });
    };

    return _this;
  }

  (0, _createClass2.default)(PricingGridLayout, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deleteImmediately();
      this.clearAddedTimeout();
      this.resetImmediately();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          results = _this$props.results,
          quantities = _this$props.quantities,
          priceMode = _this$props.priceMode,
          widthOfPrices = _this$props.widthOfPrices,
          widthOfQuantity = _this$props.widthOfQuantity,
          onShippingSubmit = _this$props.onShippingSubmit,
          shipmentConfiguration = _this$props.shipmentConfiguration;
      if (!results) return _react.default.createElement("div", null);
      var _this$state3 = this.state,
          showAlert = _this$state3.showAlert,
          addedQuantities = _this$state3.addedQuantities,
          deletedIndex = _this$state3.deletedIndex,
          resetting = _this$state3.resetting;
      return _react.default.createElement("div", {
        className: "grid-layout"
      }, showAlert ? this.displayAlert('info', 'Your custom quantities will be saved for each category') : null, _react.default.createElement("div", {
        className: "row price-grid-table"
      }, _react.default.createElement(_QuantityTable.default, {
        key: "quantity",
        addQuantities: this.addQuantities,
        resetQuantities: this.resetQuantities,
        addedQuantities: addedQuantities,
        deleteQuantity: this.deleteQuantity,
        resetting: resetting,
        deletedIndex: deletedIndex,
        quantities: quantities,
        width: widthOfQuantity,
        onShippingSubmit: onShippingSubmit,
        shipmentConfiguration: shipmentConfiguration
      }), results.map(function (skuArray) {
        return skuArray.data ? _react.default.createElement(_PricingTable.default, {
          key: Math.random(),
          priceMode: priceMode,
          results: skuArray,
          quantities: quantities,
          addedQuantities: addedQuantities,
          resetting: resetting,
          deletedIndex: deletedIndex,
          width: widthOfPrices
        }) : _react.default.createElement(_ErrorTable.default, {
          key: Math.random(),
          quantities: quantities,
          width: widthOfPrices,
          error: skuArray.error ? skuArray.error : {
            shortMessage: 'Error',
            detailedMessage: 'Some Error Occurred',
            type: 'Error'
          }
        });
      })));
    }
  }]);
  return PricingGridLayout;
}(_react.Component);

exports.default = PricingGridLayout;